import Divider from '@mui/material/Divider';
import { useState } from "react";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export type SyncAppValues = {
    apiSecretKey: string,
    apiKey: string,
    adminToken: string,
}

type Props =
    {
        friendlyName: string,
        values: SyncAppValues,
        onChange: (field: keyof SyncAppValues, value: string) => void,
    }

export default function StoreShopifySyncForm({ friendlyName, values, onChange }: Props) {
    const [showSecret, setShowSecret] = useState(false);
    const [showAdminToken, setShowAdminToken] = useState(false);

    return (
        <div className="sync-management">
            <div className="sync-header">
                <p>Shopify Stores/{friendlyName}</p>
                <h1>Shopify Sync App</h1>
            </div>
            <Divider className="divider" />
            <div className="form-container">
                <div className="column">
                    <div className="field">
                        <p className="field-label">Application Client Secret</p>
                        <div className="field-edit">
                            <input
                                type={showSecret ? 'text' : 'password'}
                                id="syncSecret"
                                value={values.apiSecretKey}
                                onChange={(e) => onChange('apiSecretKey', e.target.value)} />
                            <button type="button" onClick={() => setShowSecret(!showSecret)}>
                                {showSecret ? <VisibilityOffIcon /> : <VisibilityIcon />}
                            </button>
                        </div>
                    </div>
                    <div className="field">
                        <p className="field-label">Application Client Key</p>
                        <div className="field-edit">
                            <input
                                type="text"
                                id="syncKey"
                                value={values.apiKey}
                                onChange={(e) => onChange('apiKey', e.target.value)} />
                        </div>
                    </div>
                    <div className="field">
                        <p className="field-label">Admin API Token</p>
                        <div className="field-edit">
                            <input
                                type={showAdminToken ? 'text' : 'password'}
                                id="syncToken"
                                value={values.adminToken}
                                onChange={(e) => onChange('adminToken', e.target.value)} />
                            <button type="button" onClick={() => setShowAdminToken(!showAdminToken)}>
                                {showAdminToken ? <VisibilityOffIcon /> : <VisibilityIcon />}
                            </button>
                        </div>
                    </div>
                    <div className="field">
                        <p className="field-label">Storefront API Token</p>
                        <div className="field-edit">
                            <input
                                type={'text'}
                                id="syncStorefrontToken"
                                defaultValue={'Not Available'}
                                onChange={() => null}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}